import ContainersPresenter from "./containers.js";
import ModalPresenter from "./modal.js";

import SubcategoriesView from "../view/subcategories.js";
export default class Subcategories {
  constructor(wrapperElement, categoriesButtonElement) {
    this._wrapperElement = wrapperElement;
    this._categoriesButtonElement = categoriesButtonElement;

    this._view = null;

    this._containersPresenter = null;
    this._modalPresenter = null;
  }

  init() {
    this._view = new SubcategoriesView(this._wrapperElement);

    if (this._view.getContainersElements().length === 0) {
      return;
    }

    this._initContainersPresenter();
    this._initModalPresenter();
  }

  _initContainersPresenter() {
    this._containersPresenter = new ContainersPresenter(
        this._view.getContainersElements()
    );
    this._containersPresenter.init();
  }

  _initModalPresenter() {
    if (!this._categoriesButtonElement) {
      return;
    }


    this._modalPresenter = new ModalPresenter(
        this._categoriesButtonElement,
        this._wrapperElement
    );
    this._modalPresenter.init();
  }
}
